<template>
  <base-section id="about-our-product">
    <base-section-heading
      icon="mdi-vuetify"
      title="How to Use"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="4"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutOurProduct',

    data: () => ({
      cards: [
        {
          title: 'Step 1',
          subtitle: 'Name your party!',
          text: 'Choose something simple, but not TOO generic...',
          callout: '1',
        },
        {
          title: 'Step 2',
          subtitle: 'Share your party name.',
          text: 'Tell your party members to visit InstaParty.gg/<party-name>',
          callout: '2',
        },
        {
          title: 'Step 3',
          subtitle: 'Party Up!',
          text: 'Click the JOIN button, you\'ll be taken straight to your own private Discord voice channel.',
          callout: '3',
        },
      ],
    }),
  }
</script>
